module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Aurore-meisje-goudfolie-foliedruk-drukwerk-thumbnail.d895a21f.png";